<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Consult',
})
</script>
<template>
  <div class="cooperation-settle">
    <div :id="props.componentId" class="contact-content"></div>
    <div class="cooperation-settle-flex">
      <div class="cooperation-settle-flex-left">
        <div class="flex-left-title">立即咨询</div>
        <div class="flex-left-content">我们的客户经理将尽快与您联系</div>
      </div>
      <div class="cooperation-settle-flex-right">
        <el-form
          :inline="true"
          :model="culeForm"
          ref="formRef"
          :rules="rules"
          class="demo-form-inline"
        >
          <div style="display: flex">
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="culeForm.name" placeholder="请输入您的姓名" />
            </el-form-item>
            <el-form-item label="手机号：" prop="phone">
              <el-input
                v-model="culeForm.phone"
                placeholder="请输入您的手机号"
              />
            </el-form-item>

            <el-form-item label="企业名称：" prop="enterpriseName">
              <el-input
                v-model="culeForm.enterpriseName"
                placeholder="请输入您的企业名称"
              />
            </el-form-item>
          </div>
          <el-form-item label="需求描述：" prop="content" class="item-textarea">
            <el-input
              type="textarea"
              v-model="culeForm.content"
              maxlength="300"
              :rows="3"
              show-word-limit
              placeholder="请描述您的需求，以便我们更好的为您服务（300字以内）"
            />
          </el-form-item>
          <el-form-item label="" prop="isPassing" class="dragContent">
            <div class="drag">
              <drag-verify
                ref="dragVerify"
                :width="360"
                :height="40"
                v-model:isPassing="culeForm.isPassing"
              />
            </div>
          </el-form-item>
          <div class="confirm-btn">
            <el-button
              id="solution-consult-submit-button"
              type="primary"
              @click="confirm(formRef)"
              :loading="loading"
              >立即提交</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
    <div class="mask" v-show="dialogVisible">
      <div class="dialog">
        <div class="dialog-content">
          <img
            src="https://aio-qos.geovisearth.com/getfile/24/dqyun/images/settle/27%402x.png"
          />
          <div class="dialog-content-title">提交成功</div>
          <div class="dialog-content-link">
            我们的客户经理将在2个工作日内与您联系
            <div>请耐心等待</div>
          </div>
        </div>
        <div class="close-btn">
          <el-button type="primary" @click="close">我知道了</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts" name="Consult">
import DragVerify from '@/components/DragVerify/Index.vue'
import type { FormInstance, FormRules } from 'element-plus'
import { checkPhoneNumber } from '@/utils/eleValidate'
import { clueFormAddApi } from '@/api/modules/clue'
import DqMessage from '@/utils/message-ssr/index'

interface ConsultType {
  componentId: string
  source?: string
}

const props = defineProps<ConsultType>()

interface SettleForm {
  id?: string
  phone: string
  name: string
  sourceId?: string
  type?: string
  typeId?: string
  content: string
  cityId?: number
  portalProductId: number
  enterpriseName: string
  isPassing?: boolean
}

let culeForm = reactive<SettleForm>({
  name: '',
  content: '',
  phone: '',
  sourceId: '1',
  typeId: '6',
  cityId: 0,
  enterpriseName: '',
  portalProductId: 5,
  isPassing: false
})
const formRef = ref<FormInstance>()
const rules = reactive<FormRules>({
  name: [
    {
      required: true,
      min: 1,
      max: 50,
      message: '请输入姓名，长度不超过50个字',
      trigger: 'blur'
    }
  ],
  phone: [{ required: true, validator: checkPhoneNumber, trigger: 'blur' }],
  content: [
    {
      required: true,
      min: 1,
      max: 300,
      message: '请输入您的需求，长度不超过300个字',
      trigger: 'blur'
    }
  ],
  enterpriseName: [
    {
      required: true,
      min: 1,
      max: 50,
      message: '请输入企业姓名，长度不超过50个字',
      trigger: 'blur'
    }
  ],
  isPassing: [
    {
      type: 'enum',
      message: '请拖动滑块验证',
      enum: [true]
    }
  ]
})
let loading = ref(false)
let dialogVisible = ref<boolean>(false)
// let isPassing = ref<boolean>(false)

const resetForm = () => {
  formRef.value?.resetFields()
  // isPassing.value = false
}
const close = () => {
  // todo
  dialogVisible.value = false
  resetForm()
}

const confirm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return

  await formEl.validate(async (valid) => {
    if (!valid) return
    loading.value = true
    try {
      // 新增
      const { code, msg } = await clueFormAddApi({
        ...culeForm,
        type: '1',
        productName: props.source || ''
      })
      if (code) {
        // const { ElMessage } = await import('element-plus')
        // ElMessage.error(msg)
        DqMessage.error(msg)
        return
      }
      dialogVisible.value = true
      loading.value = false
      window.zhuge &&
        window.zhuge.track('立即咨询提交', {
          解决方案名称: props.source,
          提交结果: '是'
        })
    } catch (error) {
      loading.value = false
      window.zhuge &&
        window.zhuge.track('立即咨询提交', {
          解决方案名称: props.source,
          提交结果: '否'
        })
    } finally {
      loading.value = false
    }
  })
}
onBeforeRouteUpdate(async () => {
  if (!formRef.value) return
  formRef.value.resetFields()
})
</script>
<style scoped lang="scss">
.cooperation-settle {
  padding: 72px 0;
  opacity: 1;
  .cooperation-settle-flex {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    width: 1240px;
    margin: 0 auto;
    .cooperation-settle-flex-left {
      width: 196px;
      height: 58px;
      .flex-left-title {
        font-size: 28px;
        font-weight: 400;
        color: rgba(20, 20, 25, 1);
        text-align: left;
        letter-spacing: 0;
        vertical-align: top;
      }
      .flex-left-content {
        font-size: 14px;
        font-weight: 400;
        color: rgba(107, 111, 128, 1);
        text-align: left;
        letter-spacing: 0;
        vertical-align: top;
      }
    }
    .cooperation-settle-flex-right {
      width: 964px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(145, 152, 168, 1);
      text-align: left;
      letter-spacing: 0;
      vertical-align: top;
      border-radius: 2px;
      opacity: 1;
      :deep(.el-form-item) {
        // width: 300px;
        display: flex;
        flex: 1;
        flex-direction: column;
        margin-right: 0;
        .el-input__wrapper {
          // width: 300px;
        }
        .el-form-item__label {
          justify-content: flex-start;
        }
      }
      .el-form-item:nth-child(3) {
        margin-right: 0;
      }
      .item-textarea {
        width: 965px;
        margin-top: 10px;
        margin-right: 0;
      }
      .el-input {
        width: 300px;
        height: 40px;
        margin-right: 32px;
        border-radius: 2px;
        opacity: 1;
      }
      .el-input:nth-child(3) {
        margin-right: 0;
      }
      .el-textarea {
        width: 964px;
        border-radius: 2px;
        opacity: 1;
      }
      .dragContent {
        display: inline-block;
        margin-left: 50%;
        transform: translate(-50%, 0);
      }
      .drag {
        margin-top: 32px;
        border-radius: 2px;
        opacity: 1;
        .drag_verify {
          margin: 0 auto;
        }
      }
      .confirm-btn {
        width: 160px;
        height: 44px;
        margin: 0 auto;
        margin-top: 24px;
        text-align: center;
        .el-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 160px;
          height: 44px;
          padding: 0 48px;
          background: rgba(51, 133, 255, 1);
          border-radius: 2px;
          opacity: 1;
        }
      }
    }
  }
  .mask {
    /* 使用固定定位让元素撑满全屏 */
    position: fixed;
    inset: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.8);
    .dialog {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 456px;
      height: 331px;
      margin: auto;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(210, 214, 219.3, 1);
      border-radius: 2px;
      box-shadow: 0 0 40px 0 rgba(16, 28, 51, 0.1);
      opacity: 1;
      .dialog-content {
        width: 360px;
        margin: 48px;
        img {
          width: 64px;
          height: 64px;
          margin: 0 auto;
        }
        .dialog-content-title {
          margin: 0 auto;
          margin-top: 32px;
          font-size: 18px;
          font-weight: 700;
          color: rgba(20, 20, 25, 1);
          text-align: center;
          letter-spacing: 0;
          vertical-align: top;
        }
        .dialog-content-link {
          margin: 0 auto;
          margin-top: 8px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(107, 111, 128, 1);
          text-align: center;
          letter-spacing: 0;
          vertical-align: top;
        }
      }
      .close-btn {
        background: rgba(51, 133, 255, 1);
        border-radius: 2px;
        opacity: 1;
        .el-button--primary {
          width: 360px;
          height: 44px;
        }
      }
    }
  }
  .contact-content {
    position: relative;
    top: -180px;
  }
}
</style>
